

import { QueryRequestProvider } from './header-details/core/QueryRequestProvider'
import { QueryResponseProvider } from './header-details/core/QueryResponseProvider'
import { ListViewProvider, useListView } from './header-details/core/ListViewProvider'
import { KTCard } from '../../../_dashboard/helpers'
import { Header } from './Header'

const HeaderComponent = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
     <Header/>
      </KTCard>
    </>
  )
}

const HeaderListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <HeaderComponent />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {HeaderListWrapper}
